import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../css/Calendar.css';

const ExportButton = ({ username }) => {
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleExport = () => {
    setShowConfirmation(true);
  };

  const handleConfirmDownload = () => {
    const API_URL = process.env.REACT_APP_BACKEND_URL;
    axios
      .get(`${API_URL}/export/${username}`, { responseType: 'blob' })
      .then((response) => {
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'events.xlsx';
        link.click();
        setShowConfirmation(false); // Close the pop-up after initiating download
      })
      .catch((error) => {
        console.error('Failed to export events:', error);
      });
  };

  const handleCancelDownload = () => {
    setShowConfirmation(false);
  };

  useEffect(() => {
    if (showConfirmation) {
      document.body.style.overflow = 'hidden'; // Prevent scrolling when the pop-up is open
    } else {
      document.body.style.overflow = 'auto'; // Enable scrolling when the pop-up is closed
    }
  }, [showConfirmation]);

  return (
    <>
      <button className="create-button" onClick={handleExport}>
        Εξαγωγή Συμβάντων σε Excel
      </button>
      {showConfirmation && (
        <div className="popup">
          <div className="popup-content">
            <h1>Επιβεβαίβωση</h1>
            <p className="justified-text">&nbsp;&nbsp;&nbsp;&nbsp;Είστε σίγουροι ότι θέλετε να κατεβάσετε το αρχείο;</p>
            <div className="confirm-button">
              <button className="confirm-button" onClick={handleConfirmDownload}>
                Ναι
              </button>
              <button className="cancel-button" onClick={handleCancelDownload}>
                Οχι
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ExportButton;
